import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor, FormBuilder, FormControl,
  FormControlDirective,
  FormGroup,
  FormGroupDirective,
  NG_VALUE_ACCESSOR, Validators
} from '@angular/forms';
import { BaseUiFormControl } from '../../base-ui-form-control';
import {Subscription} from "rxjs";

@Component({
  selector: 'ui-bs-typeahead',
  templateUrl: './ui-bs-typeahead.component.html',
  styleUrls: ['./ui-bs-typeahead.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:  forwardRef(() => UiBsTypeaheadComponent),
    multi: true
  }]
})

export class UiBsTypeaheadComponent extends BaseUiFormControl implements ControlValueAccessor {
  form: FormGroup;
  subscriptions: Subscription[] = [];

  @Input() set lookup(value: any[]) {
    if (value) {
      this.filteredList = Object.assign([], value);
    }
  }
  @Input() placeholder?: string = "Search Options";

  filteredList: any[] = [];
  showList: boolean = false;

  constructor(
    public controlContainer: ControlContainer,
    private formBuilder: FormBuilder,
    public parenf:FormGroupDirective) {
    super(controlContainer);
  }
  get value() {
    return this.form.value;
  }
  set value(value) {
    //this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }
  onNoResults(noResult: boolean) {
    if (noResult) {
      this.control.setErrors({ noResults: { valid: false, value: this.control.value }});
    }
  }
  onChange: any = () => {};
  onTouched: any = () => {};
  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      //this.form.reset();
    }
  }
  setDisabledState(isDisabled: boolean): void {
    if(isDisabled)
      this.control.disable();
    else
      this.control.enable();
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  clear() {

  }
  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.control.valid ? null : { profile: { valid: false } };
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
